<template>
  <div
    class="drop-area mb-3"
    :class="{ 'cursor-pointer': enableClick, 'cursor-not-allowed': !enableClick }"
    @click="clickAction"
    @dragover.prevent
    @drop.prevent="dropAction"
  >
    <div :class="isMaxWidthReached ? 'd-flex align-items-center' : 'mt-5'">
      <div :class="{ 'my-3': !isMaxWidthReached }">
        <svg width="82" height="53" viewBox="0 0 82 53" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M25 20.4521L41 34.0371L56 1.44141L81 51.0183H1L25 20.4521Z"
            stroke="#06263E"
            stroke-opacity="0.45"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle cx="26" cy="6" r="4" fill="#1C8280" />
        </svg>
      </div>
      <div :class="{ 'text-start': isMaxWidthReached }">
        <h4 v-if="!isMaxWidthReached" class="display-5">{{ displayTextOne }}</h4>
        <h6 v-if="!isMaxWidthReached" class="display-6 text-muted mb-5">{{ displayTextTwo }}</h6>
        <h6 v-if="isMaxWidthReached" class="display-6 text-muted">{{ displayTextThree }}</h6>
      </div>
    </div>
  </div>
</template>

<script>
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';

export default {
  name: 'DropArea',
  mixins: [languageMessages, globalMixin],
  props: {
    isMaxWidthReached: {
      type: Boolean,
      default: false
    },
    enableClick: {
      type: Boolean,
      default: false
    },
    displayTextOne: {
      type: String,
      required: true
    },
    displayTextTwo: {
      type: String,
      required: true
    },
    displayTextThree: {
      type: String,
      required: true
    }
  },
  methods: {
    clickAction() {
      if (this.enableClick) this.$emit('upload');
    },
    dropAction(event) {
      if (this.enableClick) this.$emit('drop', event);
    }
  }
};
</script>

<style lang="scss" scoped>
.drop-area {
  border: 1px dashed #ccc;
  padding: 20px 20px 0px 20px;
  text-align: center;
  border-radius: 5px;
  height: 300px;
}
@media only screen and (max-width: 600px) {
  .drop-area {
    height: 100px !important;
  }
}
.cursor-not-allowed {
  cursor: not-allowed;
}
</style>
